module.exports = __webpack_public_path__ + "img/mara_1kl.eb871c59.jpg";